module.exports = __webpack_public_path__ + "static/img/pickup-singlecab-red.01b0567.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-singlecab-red.svg
// module id = nQK1
// module chunks = 74